"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Easing = void 0;
var Easing;
(function (Easing) {
    Easing["Linear"] = "u-linear";
    Easing["Ease"] = "u-ease";
    Easing["EaseIn"] = "u-ease-in";
    Easing["EaseOut"] = "u-ease-out";
    Easing["EaseInOut"] = "u-ease-in-out";
})(Easing = exports.Easing || (exports.Easing = {}));
//# sourceMappingURL=Easing.js.map